/**
 * Proje modülü durum/öncelik sözlüğü — TEK kaynak.
 * Sayfa, drawer ve formlar aynı etiket/renk/ikonu buradan alır (CLAUDE.md kural 5:
 * durum = renk + ikon + metin).
 */

export type TaskStatus = "backlog" | "todo" | "in_progress" | "in_review" | "blocked" | "done" | "cancelled";
export type TaskPriority = "low" | "medium" | "high" | "critical";
export type TaskRole = "owner" | "watcher" | "auditor" | "manager";
export type ProjectStatus = "planning" | "active" | "on_hold" | "completed" | "cancelled";

/** Panoda soldan sağa kolon sırası. */
export const BOARD_COLUMNS: TaskStatus[] = ["backlog", "todo", "in_progress", "in_review", "blocked", "done"];

interface Meta { label: string; cls: string; icon: string }

const task: Record<TaskStatus, Meta> = {
  backlog: { label: "Havuz", cls: "", icon: "inbox" },
  todo: { label: "Yapılacak", cls: "b-info", icon: "list" },
  in_progress: { label: "Devam Ediyor", cls: "b-primary", icon: "play" },
  in_review: { label: "İncelemede", cls: "b-warn", icon: "eye" },
  blocked: { label: "Engellendi", cls: "b-danger", icon: "alertTriangle" },
  done: { label: "Tamamlandı", cls: "b-success", icon: "checkCircle" },
  cancelled: { label: "İptal", cls: "", icon: "x" },
};

const project: Record<ProjectStatus, Meta> = {
  planning: { label: "Planlama", cls: "b-info", icon: "calendar" },
  active: { label: "Aktif", cls: "b-primary", icon: "play" },
  on_hold: { label: "Beklemede", cls: "b-warn", icon: "clock" },
  completed: { label: "Tamamlandı", cls: "b-success", icon: "checkCircle" },
  cancelled: { label: "İptal", cls: "", icon: "x" },
};

const roleLabel: Record<TaskRole, string> = {
  owner: "Sorumlu",
  manager: "Yönetici",
  auditor: "Denetçi",
  watcher: "İzleyici",
};

export const STATUS_META = { task, project, roleLabel };

export const PRIORITY_META: Record<TaskPriority, Meta> = {
  low: { label: "Düşük", cls: "", icon: "chevronDown" },
  medium: { label: "Orta", cls: "b-info", icon: "minus" },
  high: { label: "Yüksek", cls: "b-warn", icon: "chevronUp" },
  critical: { label: "Kritik", cls: "b-danger", icon: "alertTriangle" },
};

/**
 * Sunucudaki TASK_TRANSITIONS ile AYNI tablo — UI yalnız gidilebilir durumları
 * göstersin diye. Sunucu her hâlükârda kendi doğrulamasını yapar; burası
 * kullanıcıyı kesin reddedilecek bir seçimle karşılaştırmamak içindir.
 */
export const TASK_TRANSITIONS: Record<TaskStatus, TaskStatus[]> = {
  backlog: ["todo", "in_progress", "cancelled"],
  todo: ["backlog", "in_progress", "blocked", "cancelled"],
  in_progress: ["todo", "in_review", "blocked", "done", "cancelled"],
  in_review: ["in_progress", "done", "blocked", "cancelled"],
  blocked: ["todo", "in_progress", "cancelled"],
  done: ["in_progress"],
  cancelled: ["backlog"],
};
